import React from 'react';
import nAutorizado from "./nAutorizado.svg";
import BotaoVoltar from '../../components/botoes/BotaoVoltar';
import './emConstrucao.css';

export default function NaoAutorizado() {
    return (
        <div className="container-system-page">
            <div>
                <h5 className="mb-3">Você não possui permissão para acessar essa página</h5>
                <img
                    src={nAutorizado}
                    className="mx-auto"
                    style={{
                        maxHeight: "100%",
                        width: "10rem",
                        objectFit: "cover",
                    }}
                    alt="Imagem não encontrada"
                />
            </div>
            <BotaoVoltar className="botao-voltar" />
        </div>
    );
}
